import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Address } from '../models/api/address.model';

@Injectable()
export class AddressesService {
  constructor(private readonly httpClient: HttpClient) {}

  public getAddresses(postCode: string): Observable<Array<Address>> {
    return this.httpClient.get<Array<Address>>('/addresses/getAddresses', {
      params: {
        postCode
      }
    });
  }
}
